import { useNuxtApp } from 'nuxt/app'

export default defineNuxtRouteMiddleware(() => {
  const nuxtApp = useNuxtApp()
  if (!nuxtApp.$authorization.isAdmin()) {
    return navigateTo('/')
  }
})
